// extracted by mini-css-extract-plugin
export default {"zoomModal":"A1-z"};